<template>
    <div class="">
        <div v-if="userCase" class="container">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="card">
                        <div class="card-header blue-gradient">
                            <h5 class="m-0">Caso número {{userCase.id}} - {{userCase.entity}}</h5> 
                        </div>
                        <div class="card-body">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="m-0">Solicitante</h6>  
                                </div>
                                <div class="card-body">
                                    <p class="text-left card-text m-0"><b>Nombre:</b> {{userCase.issuer.name}}</p>
                                    <p class="text-left card-text m-0"><b>Correo:</b> {{userCase.issuer.email}}</p>
                                    <p class="text-left card-text m-0"><b>Dirección:</b> {{userCase.issuer.address}}</p>
                                    <p class="text-left card-text m-0"><b>Número de teléfono:</b> {{userCase.issuer.phone_number}}</p>
                                    <p class="text-left card-text m-0"><b>Documento:</b> {{userCase.issuer.document}}</p>
                                </div>
                            </div>
                            <div class="card mt-3">
                                <div class="card-header">
                                    <h6 class="m-0">Caso</h6>  
                                </div>
                                    <div class="card-body">
                                        <h6 class="text-left"><b>Fecha de solicitud:</b> {{date}}</h6>
                                        <h6 class="text-left"><b>A las: </b>{{time}}</h6>
                                        <p class="text-left card-text"><b>Organización:</b> {{userCase.city}}</p>
                                        <p class="text-left card-text"><b>Descripción:</b></p>
                                        <p class="text-left">{{userCase.description}}</p>
                                    </div>
                            </div>
                            <a v-if="userCase.file != null" :href="userCase.file" class="mt-2 btn btn-primary">Descargar archivo</a>
                        </div>
                    </div>
                </div>
                <div v-if="picture" class="col-12 col-md-6">
                    <div class="card">
                        <div class="card-header blue-gradient">
                            <h5 class="m-0">Anexos</h5>  
                        </div>
                        <div class="card-body">
                            <img style="width: 100%" :src="picture" alt="">
                        </div>
                        <video controls class="mt-2">
                            <source :src="userCase.video" type="video/mp4">
                        </video>
                        <audio controls class="mt-2">
                            <source :src="userCase.audio" type="video/mp4">
                        </audio>
                    </div>
                </div>     
                
                <div v-else class="col-12 col-md-6">
                    <div class="card">
                        <div class="card-header orange-gradient">
                            <h5 class="m-0">Anexos</h5>  
                        </div>
                        <div class="card-body">
                            <p class="text-left">El caso actual no cuenta con anexos...</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Map -->
            <div class="row mt-4" v-show="userCase.has_location">
                <div class="col-12">
                    <div id="map" class="map-canvas"></div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <nav>
                        <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <a v-if="user.type == 'entity'" class="nav-item nav-link" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Responder</a>
                            <a class="nav-item nav-link active" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Respuestas</a>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div class="tab-pane fade border rounded p-3" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                            <div class="card p-3">
                                <div class="card-body">
                                    <div class="card-header col-12 blue-gradient">Ingresa una nueva respuesta: </div>
                                    <div class="form-group mt-3">
                                        <label for="body">Respuesta: </label>
                                        <textarea name="body" id="body" class="form-control" cols="30" rows="5" v-model="response.body"></textarea>
                                    </div>
                                    <input type="button" name="" id="" value="Subir pdf" class="btn btn-danger btn-block" @click="$refs.pdfButton.click()">
                                    <small v-if="pdfName">PDF: {{pdfName}}</small>
                                    <input type="button" name="" id="" value="Subir imagen" class="btn btn-info btn-block mt-3" @click="$refs.pictureButton.click()">
                                    <small v-if="pictureName">Imagen: {{pictureName}}</small>
                                    <input type="file" ref="pdfButton" style="display: none" @change="getPDF">
                                    <input type="file" ref="pictureButton" style="display: none" @change="getPicture">

                                    <input type="button" value="Enviar" class="btn btn-primary btn-block mt-3" @click="sendResponse">
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade show active border rounded p-3" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                            <div class="card mb-3" v-for="response in userCase.responses" :key="response.id">
                                <div class="card-body row">
                                    <div  :class="{ 'col-7': response.attachments, 'col-12': !response.attachments }">
                                        <div class="card-title font-weight-bold">
                                            {{response.responser}} - {{new Date(response.date).toLocaleTimeString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}}
                                        </div>
                                        <p class="font-weight-bold">Respuesta:</p>
                                        <p>{{response.body}}</p>
                                    </div>
                                    <div class="col-5" v-if="response.attachments">
                                        <div class="row">
                                            <div v-for="attachment in response.attachments" :key="attachment.id"  :class="{'col-8' : attachment.format!='pdf', 'col-4' : attachment.format=='pdf'}">
                                                <a v-if="attachment.format!='pdf'" target="_blank" :href="attachment.path">
                                                    <img :src="attachment.path" style="width:100%; box-shadow: 0px 0px 5px lightgray; padding: 5px" alt="">
                                                </a>
                                                <a v-else target="_blank" :href="attachment.path" class="text-center">
                                                    <img src="../assets/img/pdf.png" alt="" style="width:100%; box-shadow: 0px 0px 5px lightgray;"><br>
                                                    Ver anexo
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>    
</template>
<script>
import NavBar from '@/components/Navbar.vue'
export default {
    name: 'case',
    beforeMount: function(){
        var token = localStorage.getItem('session_id');
        if(!token){
            this.$router.push('/');
        } else {
            this.fetchCase();
        }
    },
    components: {
        NavBar
    },
    data(){
        return {
            id: this.$route.params.id,
            user: JSON.parse(localStorage.getItem("user")),
            userCase: null,
            picture: "",
            date: "",
            time: "",
            response: {
                picture: null,
                pdf: null,
                body: "",
            },
            pdfName: "",
            pictureName: "",
            apiUrl: process.env.VUE_APP_API,
            token: localStorage.getItem('session_id'),
            links: [
                {
                    id: 1,
                    name: 'Casos',
                    link: '#/cases'
                }
            ],
        }
    }, 
    methods: {
        renderMap(){
            let position = {lat: parseFloat(this.userCase.latitude), lng: parseFloat(this.userCase.longitude)};
            setTimeout(() => {
                let map = new google.maps.Map(document.getElementById('map'), {
                    center: position,
                    zoom: 15,
                    mapTypeId: 'hybrid'
                });

                var marker = new google.maps.Marker({
                    position: position,
                    map: map,
                    title: 'Ubicación del caso'
                });
            }, 1000);
        },
        fetchCase: function(){
            let loader = this.$loading.show();
            this.$http.get(
                `${this.apiUrl}/${this.user.type}/cases/${this.id}`, 
                {headers: {Authorization: `Bearer ${this.token}`}}
            )
            .then(data => {
                this.userCase = data.body.data;
                
                this.picture = this.userCase.picture;
                this.date = this.userCase.created_at.split(" ")[0];
                this.time = this.userCase.created_at.split(" ")[1];
                loader.hide();
                if(this.userCase.has_location){
                    this.renderMap();
                }
            })
        },getPDF: function(e){
            let pdf = e.target.files[0];
            console.log(pdf);

            if(pdf.type != "application/pdf"){
                this.$dialogs.alert("El archivo debe ser de tipo pdf", {title: "Error", size: "sm"});
                return;
            }

            this.pdfName = pdf.name;
            this.response.pdf = pdf;
        },
        getPicture: function(e){
            let picture = e.target.files[0];
            console.log(picture);

            if(!picture.type.includes("image")){
                this.$dialogs.alert("El archivo debe ser de tipo imagen", {title: "Error", size: "sm"});
                return;
v            }

            this.pictureName = picture.name;
            this.response.picture = picture;
        },
        sendResponse: function()
        {
            let _this = this;
            if(this.response.body == ""){
                this.$dialogs.alert("Debe llenar el campo respuesta para poder enviar", {title: "Error", size: "sm"});
                return;
            }

            var formData = new FormData();
            formData.append('body', this.response.body);
            if(this.response.pdf) formData.append('pdf', this.response.pdf);
            if(this.response.picture) formData.append('picture', this.response.picture);

            let loader = this.$loading.show();

            this.$http.post(
                `${this.apiUrl}/entity/cases/${this.userCase.id}/responses`,
                formData,
                {headers: {Authorization: `Bearer ${this.token}`, 'Content-Type': 'multipart/form-data'}}
            ).then(data => {
                loader.hide();
                _this.$dialogs.alert("Respuesta enviada con éxito", {title: "Éxito", size: "sm"});
                _this.response = {};
                _this.pdfName = "";
                _this.pictureName = "";
                _this.fetchCase();

            }).catch(error => {
                _this.$dialogs.alert("Hubo un error enviado esta respuesta, vuelva a intentarlo", {title: "Error", size: "sm"});
                _this.response = {};
                _this.pdfName = "";
                _this.pictureName = "";
                loader.hide();
            });
        }
    }
}
</script>
<style lang="scss" scoped>
    @import '../assets/scss/colors';
    .card {
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
        transition: 0.5s all ease;
        will-change: transform;
        backface-visibility: hidden;
        &:hover {
            transform: scale(1.03);
            box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2);
        }
    }

    .map-canvas {
        width: 100%;
        height: 600px;
        box-shadow: 0px 0px 10px lightgray;
    }
</style>


